import { getFunnelCache } from '../default/getFunnelCache'
import { getInputById } from '../default/getInputById'
import { updateInput } from './updateInput'

export function populateFormPrefills(session_id = 'tdMainCache') {
  const sessionCache = getFunnelCache(session_id)
  const urlParams = new URLSearchParams(window.location.search)

  //Session Cache has priority, then url params and finally blank
  const email =
    sessionCache?.mainEmail ||
    sessionCache?.email ||
    urlParams.get('email') ||
    ''
  const firstName =
    sessionCache?.firstName ||
    sessionCache?.first ||
    urlParams.get('first') ||
    ''
  const lastName =
    sessionCache?.lastName || sessionCache?.last || urlParams.get('last') || ''
  const name = sessionCache?.name || `${firstName} ${lastName}`.trim()
  const phone = sessionCache?.phone || urlParams.get('phone') || ''
  const state = sessionCache?.region || ''

  const emailInput = getInputById('email')
  if (emailInput) {
    updateInput(emailInput, email)
  }
  const nameInput = getInputById('name')
  if (nameInput) {
    updateInput(nameInput, name)
  }
  const phoneInput = getInputById('phone')
  if (phoneInput) {
    updateInput(phoneInput, phone)
  }
  const stateInput = getInputById('state')
  if (stateInput) {
    updateInput(stateInput, state)
  }
}
